import Linkify from '../components/Linkify';
import React, { useEffect, useState } from 'react';

export default function PersonalTasksPage() {
  const [tasks, setTasks] = useState([]);
  const [text, setText] = useState('');
  const [date, setDate] = useState('');

  const load = () => fetch('/api/tasks/personal', { credentials: 'include' })
    .then(r => r.json()).then(setTasks);

  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!text.trim()) return;
    await fetch('/api/tasks/personal', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, task_date: date || null })
    });
    setText(''); setDate(''); load();
  };

  const toggle = async (id) => {
    await fetch(`/api/tasks/${id}/toggle`, { method: 'PATCH', credentials: 'include' });
    load();
  };

  const remove = async (id) => {
    await fetch(`/api/tasks/${id}`, { method: 'DELETE', credentials: 'include' });
    load();
  };

  const pending = tasks.filter(t => !t.done);
  const done = tasks.filter(t => t.done);

  return (
    <div style={{ padding: '32px', maxWidth: 700 }}>
      <h2 style={{ marginBottom: 24 }}>Личные задачи</h2>

      {/* Форма добавления */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 32 }}>
        <input
          value={text} onChange={e => setText(e.target.value)}
          placeholder="Новая задача..."
          onKeyDown={e => e.key === 'Enter' && add()}
          style={{ flex: 1, padding: '8px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14 }}
        />
        <input
          type="date" value={date} onChange={e => setDate(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 14 }}
        />
        <button onClick={add}
          style={{ padding: '8px 20px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
          Добавить
        </button>
      </div>

      {/* Активные */}
      {pending.length === 0 && <p style={{ color: '#9ca3af' }}>Нет активных задач</p>}
      {pending.map(t => (
        <TaskRow key={t.id} task={t} onToggle={toggle} onDelete={remove} />
      ))}

      {/* Выполненные */}
      {done.length > 0 && (
        <>
          <div style={{ margin: '24px 0 12px', color: '#6b7280', fontSize: 13, fontWeight: 600 }}>
            ВЫПОЛНЕНО ({done.length})
          </div>
          {done.map(t => (
            <TaskRow key={t.id} task={t} onToggle={toggle} onDelete={remove} />
          ))}
        </>
      )}
    </div>
  );
}

function TaskRow({ task, onToggle, onDelete }) {
  const overdue = !task.done && task.task_date && new Date(task.task_date) < new Date();
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 14px', marginBottom: 6,
      background: '#fff', borderRadius: 8,
      border: `1px solid ${overdue ? '#fca5a5' : '#e5e7eb'}`,
      opacity: task.done ? 0.6 : 1
    }}>
      <input type="checkbox" checked={task.done} onChange={() => onToggle(task.id)}
        style={{ width: 16, height: 16, cursor: 'pointer' }} />
      <span style={{ flex: 1, fontSize: 14, textDecoration: task.done ? 'line-through' : 'none' }}>
        <Linkify text={task.text}/>
      </span>
      {task.task_date && (
        <span style={{ fontSize: 12, color: overdue ? '#ef4444' : '#9ca3af' }}>
          {new Date(task.task_date).toLocaleDateString('ru-RU')}
        </span>
      )}
      <button onClick={() => onDelete(task.id)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', fontSize: 16 }}>
        ✕
      </button>
    </div>
  );
}
